import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as SessionService from "../../../../services/SessionService";
import * as ViewerService from "../../../../services/ViewerService";
import { useTranslation } from "react-i18next";
import SessionForm from "./sessionForm.view";
import PATHS from "../../../../constants/paths";
import * as MeetingService from "../../../../services/MeetingService";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const FormFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [meetings, setMeetings] = useState([]);
  const [employees, setEmployees] = useState([]);

  const setInitialValues = useCallback((data) => {
    let dataFinal = {
      meetingUuid: data.session.meetingUuid,
      speaker: data.session.speaker,
      date: data.session.date,
      // employees: data.session.employees,
    };

    // setEmployees(data.session.employees);
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    if (uuid) {
      const result = await SessionService.getSession(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }

    await getMeetings();
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        // values.employees = employees;
        let result = undefined;

        if (uuid) {
          result = await SessionService.updateSession(values, uuid);
        } else {
          result = await SessionService.addSession(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.session.messages.update.title");
            text = t("forms.session.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.session.messages.create.title");
            text = t("forms.session.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.session.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.LIST_SESSION);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      let title = "Error";
      let text = t("forms.session.messages.update.error");
      let icon = "error";

      const backendCode =
        error?.data?.error?.code || error?.response?.data?.error?.code;

      switch (backendCode) {
        case "MEETING.UUID.NOT_FOUND":
          text = t("forms.session.messages.error.meetingdNotFound");
          break;
        case "MEETING.NOT_FOUND":
          text = t("forms.session.messages.error.meetingNotFound");
          break;
        case "CENTER.NOT_FOUND":
          text = t("forms.session.messages.error.centerNotFound");
          break;
        case "MEETING.DATE.ERROR":
          text = t("forms.session.messages.error.meetingDateError");
          break;
        case "SESSION.DATE.INVALID":
          text = t("forms.session.messages.error.sessionDateInvalid");
          break;
        case "SESSION.EXISTS":
          text = t("forms.session.messages.error.sessionExists");
          break;

        default:
          if (error?.response?.data?.message) {
            text = error.response.data.message;
          }
          break;
      }

      ShowAlertDialog(title, text, icon, false, "OK", false, null);
    }
  };

  const getMeetings = async () => {
    const result = await MeetingService.listFilterAll({});
    setMeetings(result);
  };

  const handlerFilterEmployee = async (value) => {
    const filter = {
      filters: {
        name: value,
      },
    };
    const result = await ViewerService.listPersons(filter.filters);
    return result.map((item) => {
      if (item.name) {
        return `${item.nif} # ${item.name}`;
      } else {
        return `NO FACILITADO # ${item.name}`;
      }
    });
  };

  // const handleAddEmployee = (inputEmployee) => {
  //   if (inputEmployee.trim() !== "") {
  //     if (!employees.includes(inputEmployee)) {
  //       setEmployees([...employees, inputEmployee]);
  //     }
  //   }
  // };

  // const handleRemoveEmployee = (index) => {
  //   const newItems = employees.filter((_, i) => i !== index);
  //   setEmployees(newItems);
  // };

  const handleOnback = (meetingSelected) => {
    if (meetingSelected) {
      navigate(PATHS.LIST_MEETING);
    } else {
      navigate(PATHS.LIST_SESSION);
    }
  };

  return (
    <SessionForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onBack={handleOnback}
      meetings={meetings}
      // onAddEmployee={handleAddEmployee}
      // onRemoveEmployee={handleRemoveEmployee}
      onFilterEmployee={handlerFilterEmployee}
      // employees={employees}
    />
  );
};

FormFormContainer.propTypes = {
  t: PropTypes.any,
};

export default FormFormContainer;
